<template>
  <div class="questionDetailBox">
    <h5>{{ question.title }}</h5>
    <p>{{ question.content }}</p>
  </div>
</template>

<script>
export default {
  name: "questionDetail",
  metaInfo() {
    return {
      title: "问题详情",
    };
  },
  data() {
    return {
      question: "",
    };
  },
  components: {},
  mounted() {
    this.question = this.$store.state.state.question ? this.$store.state.state.question: "";
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.questionDetailBox {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ffffff;
  padding: 16px;
  h5 {
    font-size: 22px;
    font-weight: bold;
    line-height: 34px;
    color: #35363c;
    border-bottom: 0.5px solid #e0e0e0;
    padding-bottom: 16px;
  }
  p {
    font-size: 14px;
    line-height: 24px;
    color: #35363c;
    margin-top: 16px;
  }
}
</style>